import { stringify } from "query-string";
import { Dict, PaginatedApiResponse } from "../..";
import { ApiResponse, ListSort } from "../models";
import { Project } from "../models/project";

import { LeadRequirement } from "../models/requirement";
import * as http from "./http";
import ApiService from "./service";

export class RequirementService extends ApiService {
  async getRequirement(requirementId: string) {
    const url = `${this.apiDomain}/api/requirement?${stringify({
      requirementId,
    })}`;
    const response = await http.get<ApiResponse<LeadRequirement>>(
      url,
      this.store
    );
    return response.data?.data;
  }

  async findRequirementById(requirementId: string) {
    const url = `${this.apiDomain}/api/requirement/${requirementId}`;
    const response = await http.get<ApiResponse<LeadRequirement>>(
      url,
      this.store
    );
    return response.data?.data;
  }

  async findLatestRequirementById(requirementId: string) {
    const url = `${this.apiDomain}/api/requirement/latest/${requirementId}`;
    const response = await http.get<ApiResponse<LeadRequirement>>(
      url,
      this.store
    );
    return response.data?.data;
  }

  public async searchProperty(
    data: {
      page: number;
      perPage: number;
      requirementId?: string;
    } & ListSort &
      Dict
  ): Promise<PaginatedApiResponse<Project> & { lastUpdatedAt: Date }> {
    const url = `${this.apiDomain}/api/requirement/search-all/${data.requirementId}`;

    const resposne = await http.post<PaginatedApiResponse<Project>>(
      url,
      data,
      this.store
    );
    return { ...resposne.data, lastUpdatedAt: new Date() };
  }

  async getRequirementVersions(requirementId: string) {
    const url = `${this.apiDomain}/api/requirement/versions/${requirementId}`;
    const response = await http.get<ApiResponse<LeadRequirement[]>>(
      url,
      this.store
    );
    return response.data?.data;
  }

  public async getRequirements(
    data: {
      page?: number;
      search?: string;
      perPage?: number;
    } & ListSort &
      Dict
  ): Promise<PaginatedApiResponse<LeadRequirement[]>> {
    const url = `${this.apiDomain}/api/requirement/list`;
    const response = await http.post<PaginatedApiResponse<LeadRequirement[]>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }
}
